import { Component, OnInit } from '@angular/core';
import { ProjectService } from './services/project.service';
import { UserService } from './services/user.service';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from '@ag-grid-community/core';

@Component({
  selector: 'app-user-results',
  templateUrl: './user-results.component.html',
  styleUrl: './user-results.component.scss'
})
export class UserResultsComponent implements OnInit {
  projects: any = [];
  selectedProjects: any = null;
  running: boolean = false;

  users: any = [];
  colDefs: ColDef[] = [
    { field: "First Name" },
    { field: "Last Name" },
    { field: "Dexio Email" },
    { field: "National Number" },
    { field: "iMIS ID" },
    { field: "iMIS Email" },
    { field: "Member Type" },
    { field: "Status" },
    { field: "Volunteer State" },
    { field: "Chapter" },
    { field: "Indexing Total", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
    { field: "Indexed", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
    { field: "Reported as Issue while Indexing", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
    { field: "Certification Total", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
    { field: "Certified", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
    { field: "Reported as Issue while Certifying", valueFormatter: this.numberFormatter, filter: 'agNumberColumnFilter', comparator: this.numberSorter },
  ];  
  numberFormatter(params: any): string {
    if (isNaN(params.value)) { return "0"; }
    return Math.round(params.value).toString();
  }
  numberSorter(number1: string, number2: string): number {
    const number1Number: number = isNaN(Number(number1)) ? 0 : Math.round(Number(number1));
    const number2Number: number = isNaN(Number(number2)) ? 0 : Math.round(Number(number2));

    if (number1Number == 0 && number2Number == 0) { return 0; }
    if (number1Number == 0) { return -1; }
    if (number2Number == 0) { return 1; }

    return number1Number - number2Number;
  }
  private gridApi: GridApi | undefined;
  userGridOptions: GridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    paginationPageSize: 15,
    paginationPageSizeSelector: [15, 50, 100],
  };

  constructor(private readonly projectService: ProjectService, private readonly userService: UserService){ }

  ngOnInit() {
    this.projectService.getProjects().subscribe(_ => {
      this.projects = _;
    });
  }
  onGridReady = (event: GridReadyEvent) => {
    // Store the api for later use
    this.gridApi = event.api;
  }

  run() {
    this.running = true;
    this.userService.getProjectResults(this.selectedProjects).subscribe({
      next: (_: any) => {
        this.running = false;
        this.users = _;
      },
      error: (_: any) => {
        this.running = false;
        console.error(_);
      }
    });
  }
  export() {
    this.gridApi?.exportDataAsCsv();
  }
  // run() {
  //   this.running = true;
  //   this.userService.getProjectResults(this.selectedProjects).subscribe({
  //     next: (_: any) => {
  //       this.running = false;

  //       const downloadLink = document.createElement('a');
  //       downloadLink.href = URL.createObjectURL(new Blob([_.body], { type: _.body.type }));
  //       const contentDisposition = _.headers.get('content-type');
  //       const fileName = "results.csv";
  //       downloadLink.download = fileName;
  //       downloadLink.click();
  //     },
  //     error: (_: any) => this.running = false
  //   });
  // }
}
